
import { Component, Vue } from 'vue-property-decorator';
import Palette from './components/Palette.vue';
import Canvas from './components/Canvas.vue';
import About from './components/About.vue';
import SocialLinks from './components/SocialLinks.vue';
import { Color } from './model/colors';

@Component({
  components: {
    Palette,
    Canvas,
    About,
    SocialLinks,
  },
})
export default class App extends Vue {
  private penColor: Color = 0;
}
